import { LibraryElementEnum } from 'client/enums/LibraryElementEnum'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import {
  findEntityByType,
  getEntityExistingChildIds,
} from 'common/utils/entityUtils'
import ServerPageInterface from 'server/types/ServerPageInterface'
import { WebsiteLibraryElementsCreator } from 'src/editor/pages/website/website-library-elements-creator'
import { EntityWithChildIdsNewInterface } from 'src/shared/schemas/entity.schema'
import { WebsitePageInterface } from 'src/shared/types/website-entities'

// NOTE: for https://app.shortcut.com/systeme/story/86891/support-section-entity-for-website-pages-websitepagebody
export default function addSectionToWebsitePageCommand(
  page: ServerPageInterface,
): [ServerPageInterface, boolean] {
  if (
    [
      PageTypeEnum.WebsiteHome,
      PageTypeEnum.WebsiteDefault,
      PageTypeEnum.WebsitePricing,
    ].includes(page.type)
  ) {
    const entities = page.content.entities

    const websitePageBody = findEntityByType(
      entities,
      EntityTypeEnum.WebsitePageBody,
    ) as WebsitePageInterface

    const websitePageBodyChildIds = getEntityExistingChildIds(
      entities,
      websitePageBody,
    )
    if (websitePageBodyChildIds.length) {
      const websitePageBodyChildren = entities[websitePageBodyChildIds[0]]
      if (websitePageBodyChildren.type !== EntityTypeEnum.Section) {
        const section = new WebsiteLibraryElementsCreator()[
          LibraryElementEnum.LibrarySection
        ](websitePageBody.id)
        websitePageBody.childIds = [section.id]
        entities[section.id] = section

        for (const childId of websitePageBodyChildIds) {
          const child = entities[childId] as EntityWithChildIdsNewInterface
          child.parentId = section.id
          section.childIds.push(childId)
        }

        return [page, true]
      }
    }
  }

  return [page, false]
}
